import { renderAssistOffer } from '../sections/render-assist-offer';
import { renderAudiences } from '../sections/render-audiences';
import { renderColombia } from '../sections/render-colombia';
import { renderComments } from '../sections/render-comments';
import { renderCta } from '../sections/render-cta';
import { renderEnterprise } from '../sections/render-enterprise';
import { renderFeatures } from '../sections/render-features';
import { renderFooter } from '../sections/render-footer';
import { renderHeader } from '../sections/render-header';
import { renderHero } from '../sections/render-hero';
import { renderPartnersBanner } from '../sections/render-partners-banner';
import { renderPricing } from '../sections/render-pricing';
import { renderStats } from '../sections/render-stats';
import { createEl } from '../lib/dom';

/**
 * Monta la landing completa bajo `root`.
 */
export function renderSite(root: HTMLElement): void {
  root.replaceChildren();

  const shell = createEl('div', { className: 'sv-shell' });
  const main = createEl('main', { className: 'sv-main', id: 'main' });

  renderHeader(shell);
  shell.appendChild(main);

  renderHero(main);
  renderFeatures(main);
  renderAudiences(main);
  renderAssistOffer(main);
  renderPricing(main);
  renderEnterprise(main);
  renderColombia(main);
  renderPartnersBanner(main);
  renderStats(main);
  renderComments(main);
  renderCta(main);

  renderFooter(shell);

  root.appendChild(shell);
}
